import { Component, Input, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-directory-open',
  templateUrl: './icon-directory-open.component.html',
  styleUrls: ['./icon-directory-open.component.scss']
})
export class IconDirectoryOpenComponent extends IconBaseComponent implements OnInit {
  @Input() nodeType: string;

  constructor() {
    super();
  }

  ngOnInit(): void {}
}
